import React from 'react';

const ReviewSectionModal = ({ show, onClose, review = [] }) => {
    if (!show) return null;


    const formatDate = (dateString) => {
        if (!dateString) return "Unknown date"; // Handle missing date
    
        const reviewDate = new Date(dateString);
        if (isNaN(reviewDate.getTime())) return "Invalid date"; // Handle invalid date format
    
        const now = new Date();
        const diffInSeconds = Math.floor((now - reviewDate) / 1000);
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        const diffInHours = Math.floor(diffInMinutes / 60);
        const diffInDays = Math.floor(diffInHours / 24);
        const diffInWeeks = Math.floor(diffInDays / 7);
        const diffInMonths = Math.floor(diffInDays / 30);
        const diffInYears = Math.floor(diffInDays / 365);
    
        if (diffInSeconds < 60) return `${diffInSeconds} seconds ago`;
        if (diffInMinutes < 60) return `${diffInMinutes} minutes ago`;
        if (diffInHours < 24) return `${diffInHours} hours ago`;
        if (diffInDays < 7) return `${diffInDays} days ago`;
        if (diffInWeeks < 4) return `${diffInWeeks} weeks ago`;
        if (diffInMonths < 12) return `${diffInMonths} months ago`;
        return `${diffInYears} years ago`;
    };

    const formatJoinDate = (dateString) => {
        if (!dateString) return "Unknown join date";
    
        const joinDate = new Date(dateString);
        if (isNaN(joinDate.getTime())) return "Invalid join date";
    
        const now = new Date();
        const diffInYears = now.getFullYear() - joinDate.getFullYear();
        const diffInMonths = now.getMonth() - joinDate.getMonth();
        const diffInDays = now.getDate() - joinDate.getDate();
    
        if (diffInYears > 0) return `${diffInYears} years ago on WeJai`;
        if (diffInMonths > 0) return `${diffInMonths} months ago on WeJai`;
        if (diffInDays > 0) return `${diffInDays} days ago on WeJai`;
    
        return "Joined today";
    };
    
    

    return (
        <div style={{ background: '#fff', padding: '15px', borderRadius: '8px', marginBottom: '80px' }}>
            {/* Review Modal */}
            <div 
                style={{
                    position: 'fixed', 
                    bottom: '0', 
                    left: '0', 
                    width: '100%', 
                    height: '80vh', 
                    background: '#fff', 
                    borderRadius: '15px 15px 0 0', 
                    boxShadow: '0px -2px 10px rgba(0,0,0,0.2)', 
                    transition: 'transform 0.3s ease-in-out', 
                    zIndex: '1000', 
                    padding: '15px',
                    overflowY: 'auto'
                }}
            >
                {/* Modal Header */}
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    paddingBottom: '10px', 
                    borderBottom: '1px solid #ddd' 
                }}>
                    <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>All Reviews</h2>
                    <button onClick={onClose} style={{
                        background: 'none', 
                        border: 'none', 
                        fontSize: '1.5rem', 
                        cursor: 'pointer'
                    }}>
                        ✕
                    </button>
                </div>

                {/* List of Reviews */}
                {review.length > 0 ? (
                    review.map((review, index) => (
                        <div key={review.id || index} style={{ 
                            background: '#fff', 
                            padding: '15px', 
                            borderBottom: '1px solid #ddd', 
                            marginBottom: '10px' 
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                <img 
                                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSppkoKsaYMuIoNLDH7O8ePOacLPG1mKXtEng&s" 
                                    alt="User" 
                                    style={{ width: '50px', height: '50px', borderRadius: '50%', marginRight: '10px' }} 
                                />
                                <div>
                                    <strong>{review.review_name}</strong>
                                    <p style={{ fontSize: '0.8rem', color: '#666', margin: 0 }}> {formatJoinDate(review.user?.created_at)}</p>
                                </div>
                            </div>
                            <p style={{ fontSize: '0.9rem', fontWeight: 'bold', marginBottom: '5px' }}>
                            {"★".repeat(review.rating)} - {formatDate(review.created_at)}
                            </p>
                            <p style={{ fontSize: '0.95rem', color: '#333', margin: 0 }}>
                                {review.review_text}
                            </p>
                        </div>
                    ))
                ) : (
                    <p style={{ textAlign: 'center', color: '#666' }}>No reviews available.</p>
                )}
            </div>
        </div>
    );
};

export default ReviewSectionModal;
